// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.544 14.558a6.774 6.774 0 1 1-9.579-9.582 6.774 6.774 0 0 1 9.579 9.582zM20.818 17.884a.685.685 0 0 1 0 .97l-1.961 1.954a.686.686 0 0 1-.97 0l-3.55-3.555a.687.687 0 0 1 0-.97l1.958-1.955a.685.685 0 0 1 .967 0z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.027 13.491a5.273 5.273 0 0 1 0-7.45"
    />
  </svg>
);
export default SvgSearch;
